module.exports = __webpack_public_path__ + "33a8ddaeb15ba8972f432fc2f3c5a9a5.png";